// eslint-disable
import { useRef, useMemo } from "react";
import JoditEditor from "jodit-react";
import { uploadSingleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const JoditEditorWithImageField = ({
  containerClassName = "form-group mb-4",
  label,
  value,
  onChange,
  labelClassName = "",
  editorHeight = null,
  required = false,
}) => {
  const editorRef = useRef(null);
  const token = localStorage.getItem("token");

  const editorConfig = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      minHeight: editorHeight || 300,
      toolbarSticky: false,
      uploader: {
        insertImageAsBase64URI: false,
        url: url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD,
        headers: {},
        filesVariableName: () => "upload",
        isSuccess: (resp) => resp && resp.status === true,
        getMessage: (resp) =>
          resp && resp.message ? resp.message : "Upload failed",
        process: (resp) => {
          if (!resp || !resp.data) {
            return { files: [], error: 1, msg: "Upload failed" };
          }
          return {
            files: [resp.data.path],
            path: resp.data.path,
            baseurl: url.SERVER_URL,
            isImages: true,
            error: resp.status ? 0 : 1,
            msg: resp.message || "",
          };
        },
        defaultHandlerSuccess: function (data) {
          const editor = this.j || this;
          if (data.files && data.files.length) {
            const imageUrl = (data.baseurl || "") + data.files[0];
            editor.s.insertImage(imageUrl, null, "100%");
          }
        },
        defaultHandlerError: function (resp) {
          console.error("Jodit image upload error:", resp);
        },
      },
      defaultActionOnPaste: "insert_as_html",
      defaultLineHeight: 1.5,
      enter: "div",
      statusbar: false,
      sizeLG: 900,
      sizeMD: 700,
      sizeSM: 400,
      toolbarAdaptive: false,
      image: {
        openOnDblClick: true,
        editSrc: true,
        useImageEditor: false,
      },
      disablePlugins: [
        "video",
        "about",
        "classSpan",
        "file",
        "speechRecognize",
        "copyformat",
        "spellcheck",
        "add-new-line",
      ],
      events: {
        afterPaste: async (event) => {
          const clipboardData = event.clipboardData || window.clipboardData;
          const items = clipboardData.items;

          for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
              const file = items[i].getAsFile();
              if (!file) continue;

              const timestamp = Date.now();
              const fileExtension = file.type.split("/")[1];
              const newFileName = `image-${timestamp}.${fileExtension}`;
              const renamedFile = new File([file], newFileName, {
                type: file.type,
              });

              try {
                const requestUrl =
                  url.API_BASE_URL +
                  url.API_SINGLE_FILE_UPLOAD +
                  ``;
                const response = await uploadSingleFile(
                  requestUrl,
                  renamedFile,
                );

                if (response.status) {
                  const imageUrl = url.SERVER_URL + response.data.path;
                  const editorInstance = event.target;
                  const content = editorInstance.value;

                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  editorInstance.value = newContent;
                  editorInstance.events.fire("change", newContent);
                }
              } catch (error) {
                console.error("Image upload failed:", error);
              }
            }
          }
        },
      },
    }),
    [token, editorHeight],
  );

  return (
    <div className={containerClassName}>
      <label className={labelClassName}>
        {label}
        {required && <span className="text-danger">*</span>}
      </label>
      <JoditEditor
        ref={editorRef}
        value={value}
        config={editorConfig}
        onBlur={onChange}
      />
    </div>
  );
};

export default JoditEditorWithImageField;
